import React, { useState, useEffect, forwardRef } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  Divider,
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormHelperText,
  Radio,
  Button,
  Stack,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from '@mui/material';
import MaterialTable from '@material-table/core';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import RuleIcon from '@mui/icons-material/Rule';
import Filter1Icon from '@mui/icons-material/Filter1';
import Filter2Icon from '@mui/icons-material/Filter2';
import Filter3Icon from '@mui/icons-material/Filter3';
import Filter4Icon from '@mui/icons-material/Filter4';
import axios from 'axios';
import { useForm, useFieldArray, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { setFileData } from 'actions/counter';
import useStyles from './styles';
import {
  Link,
  Redirect,
  useNavigate,
  useLocation,
  useRouteMatch,
  Outlet,
} from 'react-router-dom';
// import RankingPosition from '../FormFields/SelectRankingPosition';
import UserService from 'services/user.service';
import eventBus from 'common/EventBus';

// from NinjaMain.js

const tableIcons = {
  Add: forwardRef((props, ref) => <AssignmentIndIcon {...props} ref={ref} />),
  // Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  // Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  // Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  // DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  // Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  // Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  // Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  // FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  // LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  // NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  // PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  // ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  // Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  // SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  // ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  // ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const schema = yup.object().shape({
  firstName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'First name should not contain numbers')
    .required('First name is a required field'),
});

function _sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function _submitFormRhf(data) {
  await _sleep(1000);
  alert(JSON.stringify(data, null, 2));
  // actions.setSubmitting(false);

  // insert TO DB
  // const isSuccess = await addEmployee(data);
  // if (!isSuccess) {
  //   alert(errMsg);
  // } else {
  //   setActiveStep(activeStep + 1);
  // }
}

const onSubmit = (data) => {
  // if (isLastStep) {
  //   setIsSubmittingFinal(true);
  _submitFormRhf(data);
  // } else {
  console.log('--------EmploymentPage---onSubmit-------');
  // setActiveStep(activeStep + 1);
  // actions.setTouched({});
  // actions.setSubmitting(false);
  // }
  // console.log('data', data);
};

export default function HrInspection() {
  const classes = useStyles();
  // const [errMsg, setErrMsg] = useState('');
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // const data = [
  //   { name: 'Mohammad', surname: 'Faisal', birthYear: 1995 },
  //   { name: 'Nayeem Raihan ', surname: 'Shuvo', birthYear: 1994 },
  // ];

  const columns = [
    // { title: 'Name', field: 'name' },
    // { title: 'Surname', field: 'surname' },
    // { title: 'Birth Year', field: 'birthYear', type: 'numeric' },
    //width: 30
    //width: "80%"
    // { title: 'สถานะ', field: '' },
    {
      title: 'เลขที่ใบสมัคร',
      field: 'applicantNo',
    },
    { title: 'เลขบัตรประชาชน', field: 'idCard' },
    {
      title: 'ชื่อ',
      field: 'firstName',
    },
    { title: 'สกุล', field: 'lastName' },
    { title: 'สังกัด', field: 'hDiv' },
    { title: 'รอบ', field: 'hAnnRound' },
    { title: 'ระดับคุณวุฒิ', field: 'hEdu' },
    { title: 'ตำแหน่งที่สมัคร', field: 'hPos' },
    { title: 'รหัสตำแหน่ง', field: 'hJobCode' },
    { title: 'ประเภทอัตรา', field: 'hType' },
  ];

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      title: '---title---',
      positionType: '',
      firstName: '---firstName11---',
      lastName: '---lastName1---',
      // duputy: 'รวห.',
      // rankingPositions: [{ code: 'AF', label: 'Afghanistan', phone: '93' }],
      placeOfBirth: '---',
    },
    resolver: yupResolver(schema),
  });

  const rhf = {
    useForm,
    useWatch,
    useFieldArray,
    Controller,
    control,
    setValue,
    getValues,
    errors,
  };

  // console.log('---isSubmitting----' + isSubmitting);

  // useEffect(() => {
  //   // fetch('http://localhost:3006/api/cis/employees')
  //   fetch('/api/cis/employees')
  //     .then((resp) => resp.json())
  //     .then((resp) => {
  //       setData(resp);
  //     });
  // }, []);

  useEffect(() => {
    const fetchEmps = async () => {
      try {
        const emps = await UserService.getEmployments();
        // console.log('--- HrInspection.jsx ---' + JSON.stringify(emps));
        setIsLoading(false);
        setData(emps.data);
      } catch (error) {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        console.log('err 002 : ' + _content);

        if (error.response && error.response.status === 403) {
          //401, ให้ logout เมื่อเจอ 403
          eventBus.dispatch('logout');
        }
      }
    };
    fetchEmps();
  }, []);

  //https://material-table-core.github.io/demos/actions/basic
  return (
    <React.Fragment>
      {isLoading && (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          {/* https://www.geeksforgeeks.org/how-to-use-circularprogress-component-in-reactjs/ */}
          <CircularProgress color="primary" />
          {/* <Typography>Loading data...</Typography> */}
        </div>
      )}
      {!isLoading && (
     <Grid container spacing={2} sx={{ width: '100%' }}>
          <Grid item xs={12}>
            <MaterialTable
              title="ตรวจสอบข้อมูลผู้สมัคร"
              columns={columns}
              data={data}
              icons={tableIcons}
              actions={[
                {
                  // icon: 'edit',
                  icon: Filter1Icon,
                  tooltip: 'กจ.1',
                  onClick: (event, rowData) =>
                    // alert('Applicant No.' + rowData.applicantNo),
                    // <Link to={`/product/edit/${rowData.applicantNo}`}>Edit</Link>
                    // navigate(`/employment/hr-inspection-emp/${rowData.idCard}`),
                    // gg: react router dom href blank
                    // <Link
                    //   to={`/employment/hr-inspection/`}
                    //   // params={myParams}
                    //   target={'_blank'}
                    //   rel="noopener noreferrer"
                    // >
                    //   Go
                    // </Link>
                    window.open(`/app/report1/?id=${rowData.id}`, '_blank'),
                },
                {
                  icon: Filter2Icon,
                  tooltip: 'กจ.2',
                  onClick: (event, rowData) =>
                    window.open(`/app/report2/?id=${rowData.id}`, '_blank'),
                },
                {
                  // icon: 'edit',
                  icon: Filter3Icon,
                  tooltip: 'กจ.3',
                  onClick: (event, rowData) =>
                    // alert('Applicant No.' + rowData.applicantNo),
                    // <Link to={`/product/edit/${rowData.applicantNo}`}>Edit</Link>
                    // navigate(`/employment/hr-inspection-emp/${rowData.idCard}`),
                    // navigate(`/employment/hr-inspection-report3`),
                    // <Link
                    //   to={`/employment/hr-inspection-report3`}
                    //   target="_blank"
                    // >
                    //   R3
                    // </Link>
                    // <Link to="/employment/hr-inspection-report3" target="_blank">
                    //   <button>Home</button>
                    // </Link>
                    // window.open('/app/report3', '_blank'),
                    window.open(`/app/report3/?id=${rowData.id}`, '_blank'),
                },
                {
                  // icon: 'edit',
                  icon: Filter4Icon,
                  tooltip: 'กจ.4',
                  onClick: (event, rowData) =>
                    window.open(`/app/report4/?id=${rowData.id}`, '_blank'),
                },
              ]}
              // options={{
              //   actionsColumnIndex: -1,
              // }}
              localization={{
                header: { actions: 'Report' },
                // body: {
                //   addTooltip: 'aaaaa',
                // },
              }}
              options={{
                paging: true,
                pageSize: 5, // make initial page size
                //emptyRowsWhenPaging: false,   // To avoid of having empty rows
                pageSizeOptions: [5, 10, 20, 50], // rows selection options
              }}
            />
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}
